module.exports = __webpack_public_path__ + "img/icon-folder.75d5f73e.svg";